function wrapShippingBar() {
  const bar = document.querySelector(".essential_free_shipping_bar_wrapper.top_page");
  if (bar) {
    const messageDiv = bar.querySelector('[class*="free_shipping_bar_title"]');
    if (messageDiv && !messageDiv.querySelector("a")) {
      const text = messageDiv.textContent.trim();
      let url = "#";

      if (text.includes("away from free shipping") || text.includes("Free shipping on")) {
        url = "/collections/featured";
      } else if (text.includes("You've got free shipping")) {
        url = "/checkout";
      }

      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.textContent = text;
      anchor.style.textDecoration = "none";
      anchor.style.color = "inherit";

      messageDiv.textContent = "";
      messageDiv.appendChild(anchor);
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Run once in case it's already there
  wrapShippingBar();

  // Observe DOM for future inserts
  const observer = new MutationObserver(() => wrapShippingBar());
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
});
